import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DocumentIcon from '../Icons/DocumentIcon';
import BookingCalendarIcon from '../Icons/BookingCalendarIcon';
import HouseIcon from '../Icons/HouseIcon';
import BackgroundSpinner from '../Icons/BackgroundSpinner';

export default function BookingLoadingPlaceholder() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslation();

  const loadingSteps = [
    {
      text: t('preparing_your_order'),
      icon: <DocumentIcon />,
    },
    {
      text: t('setting_up_your_booking'),
      icon: <BookingCalendarIcon />,
    },
    {
      text: t('preparing_your_room'),
      icon: <HouseIcon />,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % loadingSteps.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [loadingSteps.length]);

  return (
    <div className="flex flex-col justify-center items-center min-h-[300px] p-8">
      <div className="relative">
        {/* Spinning background circle */}
        <BackgroundSpinner />

        {/* Animated icon */}
        <div className="animate-fade-in-out">
          {loadingSteps[currentIndex].icon}
        </div>
      </div>

      {/* Loading text */}
      <div className="mt-6 text-center">
        <p className="text-xl font-semibold text-gray-700 animate-fade-in-out">
          {loadingSteps[currentIndex].text}
        </p>
        <div className="flex justify-center gap-2 mt-4">
          {loadingSteps.map((_, index) => (
            <div
              key={index}
              className={`h-2 w-2 rounded-full transition-all duration-300 ${
                index === currentIndex ? 'bg-blue-500 w-6' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fade-in-out {
          0% { opacity: 0; transform: translateY(10px); }
          20% { opacity: 1; transform: translateY(0); }
          80% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-10px); }
        }

        .animate-fade-in-out {
          animation: fade-in-out 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
